import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=064f5045&scoped=true&"
import script from "./AdminList.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=064f5045&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f5045",
  null
  
)

export default component.exports